import { useState, useEffect } from "react";
import { CircularProgress, Box } from "@mui/material";

import { useNavigate, useParams } from "react-router-dom";
import { CustomGrid } from "../../../components/tableComponent";
import { getLeagueParticipants } from "../../../services/leagues";

const PlayersTable = ({ data }) => {
  const navigate = useNavigate();
  // State management
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortModel, setSortModel] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const { id: league_id } = useParams();

  // Column definitions
  const columns = [
    {
      field: "id",
      headerName: "Player No.",
      width: 200,
      sortable: true,
      flex: 1,
    },
    {
      field: "name",
      headerName: "Name",
      width: 250,
      sortable: true,
      flex: 1.5,
    },
    {
      field: "email",
      headerName: "Email",
      width: 150,
      sortable: true,
      flex: 1,
    },
  ];

  // Event handlers
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0); // Reset to first page when changing page size
  };

  const handleSortChange = (newSortModel) => {
    setSortModel(newSortModel);
  };

  const handleRowSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const handleRowClick = (params) => {
    console.log("Row clicked:", params.row);
  };

  // Loading state
  if (loading && !data.length) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      <CustomGrid
        columns={columns}
        data={data}
        loading={loading}
        perPageCount={pageSize}
        currentPage={page}
        totalPages={totalRecords}
        isServerPagination={false}
        // isServerSorting={true}
        onChangeRecords={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        onSortModelChange={handleSortChange}
        onRowClick={handleRowClick}
        // checkboxSelection={true}
        onRowSelectionModelChange={handleRowSelectionChange}
        rowHeight={56}
        selectedCount={selectedRows.length}
        selectionModel={selectedRows}
        searchBar={null}
        disableSorting={true}
      />
    </Box>
  );
};

export default PlayersTable;
